import React from "react";
import { Box, Divider, Avatar, Text, NavLink, Image, Stack, Group } from "@mantine/core";
import { useLocation } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";
import {
  HiOutlineDocumentReport,
  HiOutlineUsers,
  HiOutlineIdentification,
  HiOutlineReceiptTax,
  HiOutlineShieldCheck,
  HiOutlineLockClosed
} from "react-icons/hi";
import { BsInboxes, BsTerminal } from "react-icons/bs";
import { MdOutlineDashboard } from "react-icons/md";
import Logo from "../../assets/logo.png";
import MenuItem from "./MenuItem";

const Sidebar = ({ toggleSidebar }) => {
  const { pathname } = useLocation();
  const { username } = useAuthStore();

  const handleToggleSidebar = () => {
    if (window.innerWidth < 768) {
      toggleSidebar();
    }
  };

  const sections = [
    {
      label: "MONITOREO",
      items: [
        { path: "/dashboard", text: "NOC Dashboard", icon: <MdOutlineDashboard size={18} /> },
        { path: "/cron-management", text: "Tareas Programadas", icon: <BsTerminal size={18} /> },
      ]
    },
    {
      label: "OPERACIONES",
      items: [
        { path: "/reports", text: "Transacciones", icon: <HiOutlineReceiptTax size={18} /> },
        { path: "/customers", text: "Clientes", icon: <HiOutlineIdentification size={18} /> },
      ]
    },
    {
      label: "CONFIGURACIÓN",
      items: [
        { path: "/plans", text: "Planes de Servicio", icon: <HiOutlineDocumentReport size={18} /> },
        { path: "/users", text: "Operadores", icon: <HiOutlineUsers size={18} /> },
      ]
    },
    {
      label: "SEGURIDAD",
      items: [
        { path: "/security/sessions", text: "Mis Sesiones", icon: <HiOutlineLockClosed size={18} /> },
      ]
    }
  ];

  return (
    <Box h="100%" py="md" px="xs" style={{ display: 'flex', flexDirection: 'column' }}>
      <Box px="xs" mb="xl">
        <Group gap="xs" wrap="nowrap">
          <Box p={4} style={{ borderRadius: '4px', backgroundColor: 'var(--mantine-color-gray-0)', border: '1px solid var(--mantine-color-gray-3)' }}>
            <Image src={Logo} w={32} h={32} fit="contain" />
          </Box>
          <Box>
            <Text fw={900} size="sm" style={{ letterSpacing: '0.5px', lineHeight: 1 }}>GC-COM</Text>
            <Group gap={4} mt={4}>
              <Box w={6} h={6} style={{ borderRadius: '50%', backgroundColor: 'var(--mantine-color-green-6)' }} />
              <Text size="xs" fw={700} c="dimmed" tt="uppercase">System Online</Text>
            </Group>
          </Box>
        </Group>
      </Box>

      <Stack gap="xl" style={{ flexGrow: 1 }}>
        {sections.map((section) => (
          <Box key={section.label}>
            <Text size="xs" fw={900} c="dimmed" px="xs" mb="xs" style={{ letterSpacing: '1px' }}>{section.label}</Text>
            <Stack gap={4}>
              {section.items.map((item) => (
                <MenuItem
                  key={item.path}
                  onClick={handleToggleSidebar}
                  path={item.path}
                  text={item.text}
                  icon={item.icon}
                  active={pathname === item.path}
                />
              ))}
            </Stack>
          </Box>
        ))}

        <Box>
          <Text size="xs" fw={900} c="dimmed" px="xs" mb="xs" style={{ letterSpacing: '1px' }}>VENCIMIENTOS</Text>
          <NavLink
            label="Calendario"
            leftSection={<BsInboxes size={18} />}
            variant="filled"
            rightSection={null}
            styles={{ label: { fontWeight: 700, fontSize: 'var(--mantine-font-size-sm)' }, root: { borderRadius: '4px' } }}
          >
            <MenuItem path="/renovation/ten-days" text="Próximos 10 días" active={pathname === "/renovation/ten-days"} />
            <MenuItem path="/renovation/thirty-days" text="Próximos 30 días" active={pathname === "/renovation/thirty-days"} />
          </NavLink>
        </Box>
      </Stack>

      <Divider my="md" variant="dashed" />

      <Box p="xs" style={{ backgroundColor: 'var(--mantine-color-gray-0)', borderRadius: '4px', border: '1px solid var(--mantine-color-gray-2)' }}>
        <Group gap="sm">
          <Avatar color="yellow" radius="xs" size="sm">
            {username?.charAt(0).toUpperCase()}
          </Avatar>
          <Box style={{ flex: 1 }}>
            <Text size="xs" fw={900} style={{ lineHeight: 1 }}>{username?.replace(/"/g, "")}</Text>
            <Text size="10px" c="dimmed" tt="uppercase" fw={700}>System Operator</Text>
          </Box>
          <HiOutlineShieldCheck size={16} color="var(--mantine-color-blue-6)" />
        </Group>
      </Box>
    </Box>
  );
};

export default Sidebar;
